<!-- 崇峰定制打印销售单 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <!-- <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" /> -->
                        <svg id="barcode" />
                    </div>
                    <div v-if="isEditTitle" class="print-title">
                        <el-input type="text" v-model="titleConfig.RValue" style="width: 200px"></el-input>
                    </div>
                    <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                    <div class="order-detail">
                        <div class="right">单号：{{ item.OrderCode }}</div>
                        <div class="right">
                            日期：
                            <el-date-picker
                                v-show="isEditOpenTime"
                                v-model="item.CreateTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                size="small"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                            <span v-show="!isEditOpenTime">{{ item.CreateTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell c-name">客户名称</div>
                        <div class="div-table-cell fdzt c-rename">{{ item.EntpCusName }}</div>
                    </div>
                    <el-table :data="tableData" :border="true" class="fkyou" style="width: 100%">
                        <el-table-column label="序号" style="width: 6%" sortable type="index"></el-table-column>
                        <el-table-column prop="GoodCode" style="width: 10%" label="UNP码">
                            <template slot-scope="scope">
                                {{ (scope.row.GoodCode || '').split(',')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column style="width: 18%" prop="APCode" show-overflow-tooltip label="编码"></el-table-column>
                        <el-table-column style="width: 16%" prop="GoodName" show-overflow-tooltip label="名称"></el-table-column>
                        <el-table-column style="width: 16%" prop="AutoSerise" show-overflow-tooltip label="车型"></el-table-column>
                        <el-table-column align="center" style="width: 8%" label="出库数">
                            <template slot-scope="scope">{{ scope.row.Count + scope.row.Unit }}</template>
                        </el-table-column>
                        <el-table-column align="center" prop="Price" style="width: 8%" label="单价"></el-table-column>
                        <el-table-column align="center" style="width: 10%" label="金额">
                            <template slot-scope="scope">{{ (scope.row.Count * scope.row.Price).toFixed(2) }}</template>
                        </el-table-column>
                        <el-table-column align="center" prop="GoodsLocation" style="width: 12%" label="仓位"></el-table-column>
                    </el-table>
                    <div class="div-table-row-bottom">
                        <div class="b-txt">合计：</div>
                        <div class="b-allnum">{{ allNum }}</div>
                        <div class="b-allprice">￥{{ allPrice }}</div>
                    </div>
                </div>
                <el-row type="flex" class="order-remark">
                    <el-col v-if="item.ShipAmount > 0" :span="6">运费：{{ item.ShipAmount }}</el-col>
                    <el-col v-else :span="6"></el-col>
                    <el-col v-if="item.DiscountType === 0" :span="6">优惠：无</el-col>
                    <el-col v-if="item.DiscountType === 1" :span="6">优惠金额：-{{ item.DiscountAmount }}</el-col>
                    <el-col v-if="item.DiscountType === 2" :span="6">整单优惠：-{{ item.DiscountRate }}%</el-col>
                    <el-col v-else :span="6"></el-col>
                    <el-col :span="6">实收金额：￥{{ (allPrice - item.DiscountAmount).toFixed(2) }}</el-col>
                    <el-col :span="6"></el-col>
                </el-row>
                <el-row type="flex" class="order-remark">
                    <el-col :span="12">备注：{{ item.Remark }}</el-col>
                    <el-col :span="12">人民币大写：{{ capitalAmount }}</el-col>
                </el-row>
                <el-row type="flex" class="order-remark">
                    <el-col :span="6">支付方式：{{ item.PayTypeName }}</el-col>
                    <el-col :span="6">发货方式：{{ item.ShipTypeName == '物流' ? item.LogisticName : item.ShipTypeName }}</el-col>
                    <el-col :span="6"> 业务员：{{ nameConfig ? (item.SNickName ? item.SNickName : item.SName) : item.SName }} </el-col>
                    <el-col :span="6">备货员：</el-col>
                </el-row>
                <!--    脚注    -->
                <div class="order-remark" v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet">
                    {{ orderData.IsHaveTitleSet ? orderData.FootNote : config.RValue }}
                </div>
                <div class="order-setcontent" v-if="isEditConfig">
                    <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                </div>
            </div>
        </div>
        <div id="lodopPrintContent" class="lodop-print-zone" style="display: none">
            <div class="print-for" v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code"></div>
                    <div class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                    <div class="order-detail">
                        <div class="right">单号：{{ item.OrderCode }}</div>
                        <div class="right">
                            日期：
                            <span>{{ item.CreateTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="lodop-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户名称</div>
                        <div class="div-table-cell fdzt" style="width: 80%">{{ item.EntpCusName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 10%">UNP码</div>
                        <div class="div-table-cell" style="width: 18%">汽配编码</div>
                        <div class="div-table-cell" style="width: 16%">配件名称</div>
                        <div class="div-table-cell" style="width: 16%">车型</div>
                        <div class="div-table-cell" style="width: 8%">出库数</div>
                        <div class="div-table-cell" style="width: 8%">售价</div>
                        <div class="div-table-cell" style="width: 10%">金额</div>
                        <div class="div-table-cell" style="width: 12%">仓位</div>
                    </div>
                    <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in item.DetailList">
                        <div class="div-table-cell fdzt" style="width: 6%">{{ Number(index) + 1 }}</div>
                        <div class="div-table-cell" style="width: 10%">{{ (AP.GoodCode || '').split(',')[0] }}</div>
                        <div class="div-table-cell" style="width: 18%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 16%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 16%">{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell fdzt" style="width: 8%">{{ AP.Count + AP.Unit }}</div>
                        <div class="div-table-cell fdzt" style="width: 8%">{{ AP.Price }}</div>
                        <div class="div-table-cell fdzt" style="width: 10%">{{ (AP.Count * AP.Price).toFixed(2) }}</div>
                        <div class="div-table-cell fdzt" style="width: 12%">{{ AP.GoodsLocation }}</div>
                    </div>
                    <div class="div-table-row-bottom">
                        <div class="b-txt">合计：</div>
                        <div class="b-allnum">{{ allNum }}</div>
                        <div class="b-allprice">￥{{ allPrice }}</div>
                    </div>
                </div>
                <div class="order-remark">
                    <div style="width: 25%" v-if="item.ShipAmount > 0">运费：{{ item.ShipAmount }}</div>
                    <div style="width: 25%" v-else></div>
                    <div style="width: 25%" v-if="item.DiscountType === 0">优惠：无</div>
                    <div style="width: 25%" v-if="item.DiscountType === 1">优惠金额：-{{ item.DiscountAmount }}</div>
                    <div style="width: 25%" v-if="item.DiscountType === 2">整单优惠：-{{ item.DiscountRate }}%</div>
                    <div style="width: 25%" v-else></div>
                    <div style="width: 25%">实收金额：￥{{ (allPrice - item.DiscountAmount).toFixed(2) }}</div>
                    <div style="width: 25%"></div>
                </div>
                <div class="order-remark">
                    <div style="width: 50%">备注：{{ item.Remark }}</div>
                    <div style="width: 50%">人民币大写：{{ capitalAmount }}</div>
                </div>
                <div class="order-remark">
                    <div style="width: 25%">支付方式：{{ item.PayTypeName }}</div>
                    <div style="width: 25%">发货方式：{{ item.ShipTypeName == '物流' ? item.LogisticName : item.ShipTypeName }}</div>
                    <div style="width: 25%">业务员：{{ nameConfig ? (item.SNickName ? item.SNickName : item.SName) : item.SName }}</div>
                    <div style="width: 25%">备货员：</div>
                </div>
                <!--    脚注    -->
                <div class="order-remark" v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet">
                    {{ orderData.IsHaveTitleSet ? orderData.FootNote : config.RValue }}
                </div>
                <div class="order-setcontent" v-if="isEditConfig">
                    <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   标题   -->
                <div class="re-set">
                    <el-button
                        class="btn-primary"
                        size="small"
                        @click="isEditTitle = true"
                        v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button
                        class="btn-primary"
                        size="small"
                        @click="setConfig()"
                        v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet"
                        >编辑脚注</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" size="small" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime"
                        >设置开单时间</el-button
                    >
                    <el-button class="btn-primary" size="small" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
                <div class="sort-set">
                    <el-button class="btn-primary" size="small" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div v-if="printType == 1" class="re-submit">
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="returnOrderList(true)" v-if="isDefaultSet">打印并返回列表</el-button>
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="continueToOrder()" v-if="isDefaultSet">打印并继续开单</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="isDefaultSet">返回列表</el-button>
                <el-button class="btn-primary" size="small" @click="returnOrderList(true)" v-if="!isDefaultSet">打印并返回列表(F1)</el-button>
                <el-button class="btn-primary" size="small" @click="continueToOrder()" v-if="!isDefaultSet">打印并继续开单(F2)</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="!isDefaultSet">返回列表(F3)</el-button>
            </div>
            <div v-else class="re-submit">
                <el-button class="btn-primary" size="small" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" size="small" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button size="small" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { constants } from 'os';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            isPreview: false,
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            nameConfig: false,
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            imgUrl: '',
            sortField: 'sortnum', //排序
            tableData: [],
            isPrint: false,
            isDefaultSet: false,
            orderData: {}
        };
    },
    watch: {
        printList(value) {
            if (this.imgUrl || value.length == 0) return;
            this.$nextTick(function () {
                // let canvas = this.$refs.canva[0];
                // QRCode.toCanvas(
                //     canvas,
                //     value[0].OrderCode,
                //     {
                //         width: 80,
                //         height: 80,
                //         margin: 0,
                //         scrollX: 0,
                //         scrollY: 0
                //     },
                //     function(error) {}
                // );

                // setTimeout(() => {
                //     html2canvas(canvas, {
                //         width: 80,
                //         height: 80,
                //         scrollX: 0,
                //         scrollY: 0
                //     }).then(canvasRes => {
                //         var imgData = canvasRes.toDataURL('image/png');
                //         this.imgUrl = imgData;
                //         canvas.style.display = 'none';
                //     });
                // }, 1000);

                JsBarcode('#barcode', value[0].OrderCode, {
                    width: 1.1,
                    height: 40,
                    fontSize: 14,
                    margin: 0,
                    displayValue: true
                });
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.printList = [];
            this.tableData = [];
            let sortField = this.$util.getLocalStorage('sale_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
                if (this.printType == 1 && !this.isDefaultSet) {
                    document.addEventListener('keydown', this.handleKeyEvent_Print);
                }
            });
        },
        handleKeyEvent_Print(e) {
            let that = this;
            let currtPrint = document.querySelector('#printContent');
            //当打印弹窗关闭时载触发当前事件时移除监听
            if (!currtPrint || !currtPrint.parentElement || !currtPrint.parentElement.domInserted) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                return;
            }            
            if (that.loading|| that.isEditConfig || that.isEditTitle) return;
            let key = window.event.keyCode;
            e.preventDefault();
            // 打印并继续开单(F1)
            if (key == 112) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(true);
            }
            // 打印并返回列表(F2)
            else if (key == 113) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.continueToOrder();
            }
            // 返回列表(F3)
            else if (key == 114) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(false);
            }

            return;
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxssj', 'dyxs', 'dyshbt', 'dyywync', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxssj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxs':
                                    this.config = data[i];
                                    break;
                                case 'dyshbt':
                                    this.titleConfig = data[i];
                                    break;
                                case 'dyywync':
                                    this.nameConfig = result;
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                    .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 12px 0;
                    }
                    .order-code {
                        width: 80px;
                        height: 80px;
                        display: inline-block;
                        vertical-align: top;
                    }

                    .order-detail {
                    color: #000;
                    }

                    .lodop-print-zone{
                        width: 200mm;
                    }

                    .lodop-table-main {
                    width: 762px;
                    font-size: 12px;
                    }

                    .order-remark {
                    display: -webkit-flex;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-left: 10px;
                    margin-right: 10px;
                    padding-top: 5px;
                    color: #000;
                    }
                    .order-setcontent {
                    padding: 0px 0px 15px 0px;
                    color: #000;
                    }
                    .print-title {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    max-width: 50%;
                    margin: 0 auto;
                    text-align: center;
                    font-size: 22px;
                    font-weight: bold;
                    color: #000;
                    min-height: 26px;
                    }
                    .div-table-cell {
                        white-space: nowrap;
                        overflow: hidden !important;
                        text-overflow: clip;
                        height: auto;
                        line-height: 26px;
                        padding-left: 1px;
                        border-top: 1px solid #000;
                        border-right: 1px solid #000;
                        color: #000;
                    font-size: 12px;
                    }
                    .div-table-row {
                        display: flex;
                        border-left: 1px solid #000;
                        margin: 0;
                        font-size: 14px;
                    }
                    .div-table-row-bottom {
                        color: #000;
                        line-height: 26px;
                        border: 1px solid #000;
                        display: flex;
                        justify-content: flex-end;
                        text-align: center;
                    }
                    .b-txt {
                        width: 15%;
                        }
                        .b-allnum {
                        width: 6%;
                        }
                        .b-allprice {
                        width: 28%;
                        }
                    .pall-count {
                        text-align: right;
                    }
                    .fdzt {
                    font-size: 14px;
                    }
                    .c-name {
                    width: 20%;
                    font-size: 16px;
                    }
                    .c-rename {
                    width: 80%;
                    font-size: 16px;
                    }
                    .sort-set {
                    margin-left: 10px;
                    }
                    .btn-primary {
                        background: #ff9900;
                        color: white;
                        margin-left: 0px;
                    }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('lodopPrintContent').innerHTML + '</body>';
                LODOP.PRINT_INIT('打印销售单');

                // LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.printList[0].OrderCode);
                // //   LODOP.PRINT_INIT('打印小票')
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                // LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                LODOP.ADD_PRINT_BARCODE(50, 10, 216, 40, '128Auto', this.printList[0].OrderCode);

                // let contentHeight = document.getElementById('lodopPrintContent').clientHeight;
                //lodopPrintContent这鬼东西是隐藏起来的，跟预览的不是同一个dom,所以得不到高度
                if (this.tableData.length <= 60) {
                    // if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 0 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        continueToOrder() {
            if (!this.isDefaultSet) {
                this.lodopPrint();
                setTimeout(() => {
                    this.$emit('closePrintDialog', 'continueToOrder');
                }, 2000);
            } else {
                this.loading = true;
                this.$util
                    .printedRecord(
                        {
                            OrderId: this.printIds[0],
                            Type: 0
                        },
                        true
                    )
                    .then(res => {
                        setTimeout(() => {
                            this.$emit('closePrintDialog', 'continueToOrder');
                        }, 2000);
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }
        },
        returnOrderList(delay) {
            if (delay) {
                if (!this.isDefaultSet) {
                    this.lodopPrint();
                    setTimeout(() => {
                        this.$router.push('/salesManage/salesOrder');
                    }, 2000);
                } else {
                    this.loading = true;
                    this.$util
                        .printedRecord(
                            {
                                OrderId: this.printIds[0],
                                Type: 0
                            },
                            true
                        )
                        .then(res => {
                            setTimeout(() => {
                                this.$router.push('/salesManage/salesOrder');
                            }, 2000);
                        });
                }
            } else {
                this.$router.push('/salesManage/salesOrder');
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetCFSaleOrderPrint',
                    data: {
                        EntpCusOId: that.printIds[0],
                        SortField: that.sortField
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    that.tableData = res.data.DetailList;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].Price;
                    }
                    that.allNum = _allNum;
                    that.allPrice = _allPrice.toFixed(2);
                    // this.printList.push(res.data);
                    this.printList = [res.data];
                    //崇峰不加运费
                    let total = (_allPrice - Number(data.DiscountAmount)).toFixed(2);
                    if (total > 0) {
                        that.capitalAmount = that.$util.moneyToCapital(total);
                    }
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        setSortField(field) {
            this.$util.setLocalStorage('sale_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>
<style lang="less">
.el-table th {
    padding-right: 0px;
}
.el-table .cell {
    padding-right: 0px;
}
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
    font-size: 12px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
    .cell {
        padding-left: 1px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: clip;
    }
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
    .cell {
        padding-left: 5px;
    }
    &:first-child .cell {
        padding-left: 5px;
        padding-right: 0;
    }
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
}

.print-table-main {
    width: 792px;

    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
        font-size: 12px;
    }
    .div-table-row-bottom {
        color: #000;
        line-height: 30px;
        border: 1px solid #000;
        border-top: none;
        display: flex;
        justify-content: flex-end;
        text-align: center;
        .b-txt {
            width: 15%;
        }
        .b-allnum {
            width: 6%;
        }
        .b-allprice {
            width: 28%;
        }
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}

.fdzt {
    font-size: 14px;
}
.c-name {
    width: 20%;
}
.c-rename {
    width: 80%;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
</style>
